export const slateMdSerializationInitialData = `### Basic layout
We support inline text styles such as **bold** and _italic_ . Additionally, we provide support for three levels of headers and hyperlinks.

Numbered lists:

1. In edit mode, we detect  '1. ' and start list automatically
1. You can use 'tab' / 'shift/tab' to indent the list

Bullet lists:

- Type '- ' to start the list
- You can create multi-level lists with 'tab' / 'shift+tab'. Example:
- Level 1
  - Level 2
  - Another item on level 2
    - Level 3
    - Another item on level 3
`;
